"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfig = exports.PROCESS_ENV = void 0;
var fromPairs_1 = __importDefault(require("lodash/fromPairs"));
exports.PROCESS_ENV = process.env;
var CONFIG_PREFIX = 'REACT_APP_CONFIG_';
var APP_CONFIG = readConfig();
function readConfig() {
    var staticConfig = (0, fromPairs_1.default)(Object.keys(exports.PROCESS_ENV)
        .filter(function (k) { return k.startsWith(CONFIG_PREFIX); })
        .map(function (k) { return [k.substring(CONFIG_PREFIX.length), exports.PROCESS_ENV[k]]; }));
    return __assign(__assign({}, staticConfig), window.APP_CONFIG);
}
function getConfig() {
    return APP_CONFIG;
}
exports.getConfig = getConfig;
